/*
 * Lib Module InputMasks
 */

Lib.InputMask = (function() {
    var self = {};

    // Document ready
    $(Lib).on('document.ready', function() {

        // Bind money
        self.bindDecimal($("input[type='text'][data-decimal]"));

        // On form submit, trigger the decimal handler
        // We do this because someone might be typing in a field and then submitting
        // This would trigger a blur but might be too late
        $("form").on('submit', function() {
            $("input[type='text'][data-decimal]").each(function() {
                self.startFormat($(this));
            });
        });
    });


    /**
     * bindDecimal function
     * @param decimalInput
     */
    self.bindDecimal = function(decimalInput) {
        decimalInput.each(function() {
            var currentDecimalInput = $(this);

            // Remove the readonly property, which is on there by default (AppoFormHelper), only if its not set on there specifically
            if (typeof currentDecimalInput.data('keep-readonly') === 'undefined') {
                currentDecimalInput.prop('readonly', 0);
            }

            // Trigger startFormat on paste and on change
            currentDecimalInput.on('paste', function() {
                var input = $(this);
                setTimeout(function() {
                    self.startFormat(input);
                }, 0);
            }).on('change', function() {
                self.startFormat($(this));
            }).trigger('change');

            // Bind change on the db field so it triggers the change on the view field
            // Which in turn starts formatting the decimals
            $("#" + $(this).data('decimal')).on('change', function() {
                self.formatFromDbField($(this));
            });
        });

    };

    /**
     * Start format function
     * @param el
     */
    self.startFormat = function(el) {

        // Get the decimals
        var decimals = el.data('decimals');

        let decimalSep = el.data('decimal-separator');
        if (typeof decimalSep === 'undefined') {
            decimalSep = ',';
        }

        let thousandSep = el.data('thousand-separator');
        if (typeof thousandSep === 'undefined') {
            thousandSep = '.';
        }

        // The the db field
        var dbField = $("#" + el.data('decimal'));

        // Get the formatted value
        var formatted = Lib.Format.decimal(el.val(), decimals, decimalSep, thousandSep);

        // Set the formatted display value
        el.val(formatted.displayValue);

        // Set the db value
        dbField.val(formatted.dbValue);
    };


    /**
     * Start format function
     * @param el
     */
    self.formatFromDbField = function(el) {

        // Get the decimals
        var decimalsField = $('#' + el.attr('id') + 'Decimal');

        let decimalSep = decimalsField.data('decimal-separator');
        if (typeof decimalSep === 'undefined') {
            decimalSep = ',';
        }

        let thousandSep = decimalsField.data('thousand-separator');
        if (typeof thousandSep === 'undefined') {
            thousandSep = '.';
        }

        // Get the formatted value
        var formatted = Lib.Format.decimal(el.val(), decimalsField.data('decimals'), decimalSep, thousandSep);

        // Set the db value
        el.val(formatted.dbValue);

        // Set the formatted display value
        decimalsField.val(formatted.displayValue);
    };


    return self;

})();
